import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  NavLink,
} from "react-router-dom";
import { useAuthListener } from "./hooks";
import {HOME,SIGN_IN,SIGN_UP,BROWSE} from "./pages";
import * as ROUTES from "./constants/routes";
import { IsUserRedirect, ProtectedRoute } from "./helpers/routes";

function App() {
  const { user } = useAuthListener();
  console.log(user);

  return (
      <Routes>
        <Route
          path={ROUTES.SIGN_IN}
          element={
            <IsUserRedirect
              user={user}
              loggedInPath={ROUTES.BROWSE}
              children={<SIGN_IN />}
            />
          }
        />
        <Route
          path={ROUTES.SIGN_UP}
          element={
            <IsUserRedirect
              user={user}
              loggedInPath={ROUTES.BROWSE}
              children={<SIGN_UP />}
            />
          }
        />
        <Route
          path={ROUTES.BROWSE}
          element={
            <ProtectedRoute user={user} children={<BROWSE />} />
          }
        />
        <Route
          path={ROUTES.HOME}
          element={
            <IsUserRedirect
              user={user}
              loggedInPath={ROUTES.BROWSE}
              children={<HOME/>}
            />
          }
        />
      </Routes>
  );
}

export default App;